import { DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';

export const LIVE_CAMPAIGN_STATUSES = [DirectSalesStatusOption.LIVE, DirectSalesStatusOption.ENDED];

export const PERSISTED_STATUSES = [
  DirectSalesStatusOption.LIVE,
  DirectSalesStatusOption.ENDED,
  DirectSalesStatusOption.CANCELLED,
];
